module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/account/manual-invoice/manual-invoice.component.css
// module id = ./src/app/account/manual-invoice/manual-invoice.component.css
// module chunks = main